import type { ChecklistItem } from '@nedelnik/shared';

/**
 * Чек-лист: счёт закрытых пунктов.
 *
 * Чек-лист не влияет на статус задачи (3.7.4) — здесь нет и не должно быть
 * ничего, что выводит «готово» из полноты списка. Счёт нужен ровно для того,
 * чтобы снаружи было видно, сколько пунктов закрыто из скольких (3.7.3).
 */

export interface ChecklistStats {
  total: number;
  done: number;
  /** Доля закрытых от 0 до 1; у пустого списка ноль, а не деление на ноль. */
  ratio: number;
}

export function checklistStats(items: readonly ChecklistItem[]): ChecklistStats {
  const total = items.length;
  const done = items.filter((item) => item.done).length;
  return { total, done, ratio: total === 0 ? 0 : done / total };
}

/** Ключ порядка, после которого встанет следующий добавленный пункт. */
export function lastOrderKey(items: readonly ChecklistItem[]): string | null {
  return items.at(-1)?.order_key ?? null;
}
